import { FaInstagram, FaFacebook, FaXTwitter } from "react-icons/fa6";


const SocialLinks = () => (
  <div className="social-links">
    <a
      href="https://www.instagram.com/revimo.eu"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaInstagram />
    </a>

    <a
      href="https://www.facebook.com/profile.php?id=61575508364904"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaFacebook />
    </a>

    <a
      href=""
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaXTwitter />
    </a>
  </div>
);
export default SocialLinks;